import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// 添加全局错误处理
const app = createApp(App)

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err)
  console.error('Component:', vm)
  console.error('Error Info:', info)
  // 这里可以添加错误上报逻辑
}

// 添加性能监控
if (process.env.NODE_ENV === 'development') {
  app.config.performance = true
}

app.use(createPinia())
app.use(router)
app.mount('#app')
